import React from 'react'

import Svg from './svg'


export default function CloseIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="sort" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M22,12 L50,40 L78,12 L88,22 L60,50 L88,78 L78,88 L50,60 L22,88 L12,78 L40,50 L12,22 Z" id="Shape" fill={color || "white"}></path>
        </g>
    </Svg>
}
